module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/couch-a783d6a1388c26861645099a0d488094.svg";